import React from "react"
import { ThreadMessage } from "../../../../types"
import BotAvatar from "../../bot-avatar"
import If from "../../if"
import InitialsAvatar from "../../initials-avatar"
import useConversationFormatter from "../use-conversation-formatter"

interface Props {
  message: ThreadMessage
  nextMsgIsSameUser: boolean
  showTimestamp: boolean
  initials: string
}

const Message = React.memo<Props>(
  ({ message, nextMsgIsSameUser, showTimestamp, initials }) => {
    const { isUser, time, text } = useConversationFormatter(message)

    return (
      <div
        className={`conversation-msg ${isUser ? "is-user" : "is-bot"} ${
          nextMsgIsSameUser ? "next-is-same-user" : ""
        }`}
      >
        <div className="flex flex-col">
          <div className="conversation-msg__inner">{text}</div>
          <If
            condition={showTimestamp}
            then={
              <time
                className={`text-sm block mt-1 ${
                  isUser ? "text-left" : "text-right"
                }`}
                dateTime={message.timestamp}
              >
                {time}
              </time>
            }
          />
        </div>
        <div className="pb-5 min-w-10 hidden md:block">
          <If
            condition={!nextMsgIsSameUser && !isUser}
            then={<BotAvatar />}
            elseCondition={!nextMsgIsSameUser && isUser}
            else={<InitialsAvatar initials={initials} />}
          />
        </div>
      </div>
    )
  }
)

Message.displayName = "Message"

export default Message
